import { type Ref, watch } from 'vue';
import { computed, ref } from 'vue';

export function usePagination(itemsCount: Ref<number>, initialRowsPerPage?: number) {
  const rowsPerPage = ref<number>(initialRowsPerPage || 10);
  const perRowSelections = ref<number[]>([10, 20, 50, 100]);
  const currentPage = ref<number>(1);

  const paginationCursor = computed(() => currentPage.value * rowsPerPage.value - rowsPerPage.value);

  // TODO: Do more check for primevue possible bug
  const needPaginate = computed(() => itemsCount.value > perRowSelections.value[0]);

  watch(rowsPerPage, (newRowsPerPage) => {
    const totalPages = Math.ceil(itemsCount.value / newRowsPerPage);

    if (totalPages > 0 && currentPage.value > totalPages) {
      currentPage.value = totalPages;
    }
  });

  return {
    paginationCursor,
    rowsPerPage,
    perRowSelections,
    currentPage,
    needPaginate,
  };
}
